var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 44,
    height: 44,
    rx: 4,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.772 19.485h-.855c-1.865 0-3.378 1.65-3.378 3.684v4.875c0 2.034 1.513 3.684 3.378 3.684h10.202c1.866 0 3.378-1.65 3.378-3.684V23.16c0-2.03-1.508-3.675-3.367-3.675h-.865M22.017 12.691v12.041M19.348 15.62l2.672-2.929 2.673 2.928",
    stroke: "#139C33",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportUpload);
export default __webpack_public_path__ + "static/media/export-upload.3d8e10aa1e1ac8895b2118107831abd6.svg";
export { ForwardRef as ReactComponent };